<template>
	<div
		class="px-4 sm:px-6 lg:px-6 py-4 bg-gray-700 flex justify-between items-center space-x-6"
	>
		<!-- this file name is fake -->
		<!-- this file name is fake -->
		<!-- this file name is fake -->

		<!-- this is the real filter: -->
		<paper-filter-slideover
			:filter-options="filterOptions"
			v-if="showFilter"
			v-on:close="showFilter = false"
			v-model="filter"
		/>

		<!-- filter button to open overlay -->
		<button
			class="relative inline-flex items-center px-2 lg:pr-4 py-1.5 font-medium text-white bg-gray-500 hover:bg-gray-400 rounded-lg flex items-center focus:ring-2 ring-gray-400"
			v-on:click="showFilter = !showFilter"
		>
			<ui-icon
				class="mr-2 flex-shrink-0 h-5 w-5"
				name="filter"
				stroke-width="2"
			/>
			{{ __("Filter") }}
			<span
				class="absolute top-0 right-0 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-orange-50 transform translate-x-1/4 -translate-y-1/2 bg-orange rounded-full"
				v-if="activeFilterCount > 0"
				>{{ activeFilterCount }}</span
			>
		</button>

		<div class="hidden md:flex flex-wrap ml-auto">
			<ui-check-box-select
				class="grid-cols-2 sm:grid-cols-3 text-sm mr-4 py-1"
				v-model="filter.locationHubs"
				:options="filterOptions.locationHubs"
				:key="'locationHubs-' + filter.locationHubs.length"
			/>
			<!-- display users offers -->
			<div class="flex items-center text-gray-100 py-1">
				<input
					type="checkbox"
					class="h-5 w-5 bg-gray-600 border-gray-600 rounded text-orange focus:ring-orange"
					id="my-items"
					v-model="filter.mine"
					value="1"
				/>
				<label
					class="ml-3 block text-sm font-medium whitespace-nowrap"
					for="my-items"
				>
					<span>{{ __("My listings") }}</span>
					<span>
						<span
							class="badge rounded-pill bg-success text-green"
							v-if="myOffersCount > 0"
							style="font-size: 0.9rem; min-width: 1.35rem; height: 1.35rem"
							>{{ myOffersCount }}</span
						>
					</span>
				</label>
			</div>
		</div>
	</div>
</template>

<script>
let options = require("../../cropOptions");
export default {
	props: {
		filterOptions: {
			type: Object,
			required: true,
		},
		hideFilterOnMobile: {
			type: Boolean,
			required: false,
		},
		myOffersCount: {
			type: Number,
			required: false,
			default: 0,
		},
		offers: {
			type: Object,
			required: true,
		},
		value: {
			type: Object,
		},
	},
	data() {
		return {
			filter: Object.assign({}, this.value),
			showFilter: false,
			// activeFilterCount: 0, // TODO
		};
	},
	computed: {
		selectedLocation: function () {
			return this.filterOptions.locationHubs
				.filter((item) => item.checked)
				.map((item) => item.name_short)
				.join(", ");
		},
		selectedProduct: function () {
			var name = [];
			this.filterOptions.productGrades.forEach((item) => {
				if (item.checked) name.push(this.__(item.name));
			});
			return name.join(", ");
		},

		activeFilterCount() {
			return (
				Object.values(this.filter).flat().length -
				2 +
				(this.filter.mine ? 1 : 0)
			);
		},
	},
	methods: {
		getSelectedIds(filterOption) {
			return filterOption
				.filter((option) => option.checked)
				.map((option) => option.id);
		},
		gradeIsFilterable(productGrade) {
			let selectedHubs = this.getSelectedIds(
				this.filterOptions["locationHubs"]
			);
			if (selectedHubs.length == 0) {
				return true;
			} else {
				let availableGrades = options.standardHubs
					.filter((h) => selectedHubs.includes(h.id))
					.flatMap((h) => Object.keys(h.productGradeOptions));
				return availableGrades.includes(productGrade);
			}
		},
		intervalCheck(month_from, month_to) {
			let selectedMonthFrom = this.filter.monthType.month_from,
				selectedMonthTo = this.filter.monthType.month_to,
				leftCheck =
					selectedMonthFrom == null ||
					month_from == null ||
					month_from >= selectedMonthFrom,
				rightCheck = selectedMonthTo == null || selectedMonthTo >= month_to;
			return leftCheck && rightCheck;
		},
	},
	watch: {
		filter: {
			deep: true,
			handler: function (val) {
				console.log("THERE");
				this.filterOptions.mine = this.filter.mine;
				this.$emit("input", val);
				console.log("EMIT", val);

				this.$emit("input", val);
				console.log("EMIT", val);
			},
		},
	},
};
</script>
